export default __webpack_public_path__ + "static/media/chainklink.f2e27f95.svg";